@if (isVisible()) {
<div class="str-selector">
  <button type="button" class="str-selector__toggle" (click)="toggleDropdown()" [attr.aria-expanded]="isOpen()"
    aria-haspopup="true">
    <span class="str-selector__toggle-text">
      @if (selectedInfrastructure(); as infra) {
        {{ getCategoryText(infra) }} <strong>{{ (infra.str_name || '').toUpperCase() }}</strong>
        <span>
          {{ getInfrastructureCodesText(infra) }}
        </span>
      } @else {
        Select Infrastructure
      }
    </span>
  </button>

  @if (isOpen()) {
  <div class="str-selector__dropdown" [class.str-selector__dropdown--open]="isOpen()">
    <div class="str-selector__search">
      <i class="fas fa-search str-selector__search-icon"></i>
      <input #searchInput type="text" class="str-selector__search-input" placeholder="Search infrastructure..."
        [value]="searchTerm()" (input)="onSearch($event)" autocomplete="off">
    </div>
    <div class="str-selector__results">
      @for (network of filteredNetworks(); track network; let i = $index) {
      <div class="str-selector__network-group">
        @if (network.Infrastructures.length > 0) {
        <button type="button" class="str-selector__network-header" (click)="toggleNetwork(i)">
          <span class="str-selector__network-name">
            Network <strong>{{ network.net_name }}</strong>
            <span class="str-selector__count">({{ network.Infrastructures.length }})</span>
          </span>
          <i class="str-selector__network-icon"
            [class.str-selector__network-icon--expanded]="isNetworkExpanded(i)">▼</i>
        </button>
        }
        @if (isNetworkExpanded(i)) {
        <div class="str-selector__network-items">
          @for (infrastructure of network.Infrastructures; track infrastructure.str_id) {
          <button type="button" class="str-selector__item str-selector__item--nested"
            (click)="selectInfrastructure(infrastructure)"
            [class.str-selector__item--selected]="selectedInfrastructure()?.str_id === infrastructure.str_id">
            {{ getCategoryText(infrastructure) }} <strong>{{ (infrastructure.str_name || '').toUpperCase() }}</strong>
            <span class="str-selector__codes">
              {{ getInfrastructureCodesText(infrastructure) }}
            </span>
          </button>
          }
        </div>
        }
      </div>
      }
      @if (filteredInfrastructures().length > 0) {
      <div class="str-selector__standalone">
        @for (infrastructure of filteredInfrastructures(); track infrastructure.str_id) {
        <button type="button" class="str-selector__item" (click)="selectInfrastructure(infrastructure)"
          [class.str-selector__item--selected]="selectedInfrastructure()?.str_id === infrastructure.str_id">
          {{ getCategoryText(infrastructure) }} <strong>{{ (infrastructure.str_name || '').toUpperCase() }}</strong>
          <span class="str-selector__codes">
            {{ getInfrastructureCodesText(infrastructure) }}
          </span>
        </button>
        }
      </div>
      }
      @if (hasNoResults()) {
      <div class="str-selector__no-results">
        <i class="fas fa-search"></i>
        <p>No infrastructures found</p>
        <small>Try adjusting your search terms</small>
      </div>
      }
    </div>
  </div>
  }
</div>
}
